import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListConfig, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';
import {ExcTab} from 'exc-tab';
import {InventoryDetailsComponent} from '../../inventory-details/inventory-details.component';
import {ExcReport} from '../../report-service.service';

@Component({
  selector: 'app-modal-report',
  templateUrl: './modal-report.component.html',
  styles: []
})
export class ModalReportComponent extends ExcTranslation implements OnInit {

  source: string = null;
  identifier: number = null;
  step = 1;
  reports: ExcReport[] = [];
  selected: {Report: ExcReport, From: Date, To: Date, Format: string, Delivery: string, Mail: string} = {Report: null, From: null, To: null, Format: null, Delivery: null, Mail: null};
  optFormats: {text: string, value: string, disabled: boolean}[] = [];
  optDelivery: {text: string, value: string, disabled: boolean}[] = [];

  dpConfig: any = {
    // minDate: new Date(),
    // maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    dateFormat: this.getGlobal('FormatDate'),
    static: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService) {
     super();
   }
  ngOnInit() {
    this.source = this.overlayConfig.data['Source'];
    this.identifier = this.overlayConfig.data['Identifier'];
    this.reports = this.overlayConfig.data['Reports'];
  }
  getTextColor(r: ExcReport): object {
    return {'color: ': (r.isAvailable(this.source) ? '#000000' : '#b0b0b0 !important')};
  }
  getBoxShadowColor(r: ExcReport): object {
    if (this.selected.Report !== null && this.selected.Report.rptID === r.rptID) {
      return {'box-shadow': '0 5px 5px -2px rgb(27, 71, 127 / 20%), 0 5px 7px 0 rgb(27, 71, 127 / 14%), 0 3px 8px 0 rgb(27, 71, 127 / 12%) !important'};
    }
    return {'box-shadow': '0 3px 3px -2px rgb(0 0 0 / 20%), 0 3px 4px 0 rgb(0 0 0 / 14%), 0 1px 8px 0 rgb(0 0 0 / 12%)'};
  }
  getCursorStyle(r: ExcReport): object {
    return {'cursor': (r.isAvailable(this.source) ? 'pointer !important' : 'not-allowed !important')};
  }
  setReport(r: ExcReport) {
    if (r.isAvailable(this.source)) {
      this.selected.Report = r;
      this.step = 2;
      for (const f of this.selected.Report.rptOutputFormats.split('|')) {
        this.optFormats.push({text: this.getRessource('FileType_' + f), disabled: false, value: f});
      }
      for (const d of this.selected.Report.rptDelivery.split('|')) {
        this.optDelivery.push({text: this.getRessource('Delivery_' + d), value: d, disabled: false});
      }
    }
  }
  proceed() {
    const obj = {proceed: true, rptID: this.selected.Report.rptID};
    if (this.identifier !== undefined && this.identifier !== null) {
      obj['ID'] = this.identifier;
    }
    if (this.selected.Report.rptTimeDriven === true) {
      const dFrom: Date = new Date(this.selected.From);
      const dTo: Date = new Date(this.selected.To);
      obj['From'] = dFrom.getDate() + '.' + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear();
      obj['To'] = dTo.getDate() + '.' + (dTo.getMonth() + 1) + '.' + dTo.getFullYear();
    }
    if (this.selected.Delivery === 'mail') {
      obj['mail'] = this.selected.Mail;
    }
    obj['out'] = this.selected.Format;
    this.overlayRef.close(obj);
  }
}
